import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import UserContext from "../contexts/UserContext";
import "../css/common.module.css";
import FetchUtil from "../utils/FetchUtil";
import { useTranslation } from 'react-i18next';

function KeyHandler() {
	var userCtx = useContext(UserContext);
	const { t } = useTranslation();
	var now = new Date();
    var lastPing = userCtx.lastPingTime;
	const navigate = useNavigate();
    const pingAfter = 1200000; //20 min
    var inPing = false;
   
    if(!lastPing){
       lastPing = now.getTime();
	   userCtx.addLastPingTime(lastPing);
	   userCtx = useContext(UserContext);
    }
    
    useEffect(() => {
       document.addEventListener('keydown',handleKeyDown);
       document.addEventListener('mousedown',handleKeyDown);
       return () => {
          document.removeEventListener('keydown',handleKeyDown);
          document.removeEventListener('mousedown',handleKeyDown);
          
       };
    }, []);
    
    const handleKeyDown=(event) => {
      let activityDate = new Date();
	  let lastActivity = activityDate.getTime();
	  if(!lastPing){
	     lastPing = userCtx.lastPingTime;
	  }
	  if(!lastPing){
	     lastPing = now.getTime();
	     userCtx.addLastPingTime(lastPing);
	  }
	  let lastPingDiff = parseInt(lastActivity, 10) - parseInt(lastPing, 10);
	  //console.log("keypress detected: "+(lastPingDiff));
	  if((lastPingDiff) >= pingAfter && !inPing){
		inPing = true;
		lastPing = lastActivity;
		userCtx.addLastPingTime(lastPing);
		keepAlive();
		inPing = false;
	  }
    }
    
    function keepAlive() {
	    const requestOptions = {
	      credentials: "same-origin",
	      method: "POST",
	      headers: { "Content-Type": "application/json" },
	      body: JSON.stringify({ source: "web", userId: userCtx.loggedInUserId }),
	    };
	    try{
	      //console.log("Before KeepAlive call2");
	      FetchUtil.fetchAPI("KeepAlive","/Service/UserService/KeepAliveSession", requestOptions, keepAliveSuccess, keepAliveFail);
	    } catch (error) {
	      // Ignore error
	      console.log(error.message);
	    }
  	}
  	
  	function keepAliveFail(redirect){
  	  if(redirect){
  	     navigate("/");
  	  }
  	}
  	function keepAliveSuccess(responseData){
	  let pingResponse;
	  if (responseData) {
	    pingResponse = responseData.pingResponse;
	    if (pingResponse && pingResponse.errorCode === "114") {
	    	navigate("/",{
		        state: {
		            	errorMessage: t("error.sessionTimeout"),
		        	},
		     });
	    }
	  }
      return true;
  	}
    
    
	return (
	  <span> </span>
	);
}

export default KeyHandler;
